<template>
  <div>
    <Dash-filter
      v-if="showFilter"
      v-model="queryString"
      :action="action"
      :default="queryString"
      :options="subscriptionFilterOptions"
      :loadingList="loadingListSubscriptions"
      @error="setError"
    />

    <subscriptions-table
      :query-string="queryString"
      :action="action"
      :has-locked="hasLocked"
    />
  </div>
</template>
<script>
import DashFilter from '@/components/project/globals/DashFilter.vue'
import FILTER_OPTIONS from './subscription-filter.enum'
import { mapGetters } from 'vuex'

import SubscriptionsTable from './SubscriptionsTable.vue'

export default {
  components: {
    DashFilter,
    SubscriptionsTable
  },
  data () {
    return {
      queryString: {
        size: 30,
        period_type: 'date_filters',
        date_filters: 'SevenDays'
      },
      action: 'GET_SUBSCRIPTIONS',
      hasLocked: false
    }
  },
  computed: {
    ...mapGetters(['loadingListSubscriptions', 'permissionIsEnabled']),
    subscriptionFilterOptions () {
      return FILTER_OPTIONS
    },

    showFilter () {
      return this.permissionIsEnabled('subscription:search')
    }
  },

  methods: {
    setError (e) {
      this.$store.dispatch('toggleLoadingListSubscription', false)
      this.hasLocked = e?.body?.hasLocked ?? false
    }
  }
}
</script>
